<template>
  <div>
    <common-table :table-columns="tableColumns" :url="url" :operate="[]" :searchs="searchs" :form-fields="formFields"
                  :permission="permission"/>
  </div>
</template>

<script>
import CommonTable from "@/components/CommonTable/CommonTable";

export default {
  name: "AgentRebateRecord",
  components: {CommonTable},
  data() {
    return {
      searchs: [{
        name: 'agentId',
        placeholder: '代理',
        type: 'select',
        selectUrl: '/agent/getAll',
        selectData: [],
      }, {
        name: 'beneficiaryUserId',
        placeholder: '分润收益人ID',
        type: 'input',
      }, {
        name: 'level',
        placeholder: '分销层别(1或2)',
        type: 'input',
      }],
      permission: {
        add: 'agentRebateRecord:add',
        update: 'agentRebateRecord:update',
        delete: 'agentRebateRecord:delete',
        deleteBatch: 'agentRebateRecord:deleteBatch'
      },
      url: {
        get: '/agentRebateRecord/listByCondition',
        add: '/agentRebateRecord/add',
        update: '/agentRebateRecord/update',
        delete: '/agentRebateRecord/delete/',
        delete_batch: '/agentRebateRecord/deleteBatch',
      },
      tableColumns: [{
        field: 'id',
        label: 'ID',
        show: true,
        width: '80',
      }, {
        field: 'agentId',
        label: '代理',
        selectUrl: '/agent/getAll',
        selectData: [],
        show: {
          type: 'select'
        },
        width: '120',
      }, {
        field: 'beneficiaryUserId',
        label: '收益人ID',
        show: true,
        width: '120',
      }, {
        field: 'level',
        label: '分佣层级',
        show: true,
        width: '100',
      }, {
        field: 'fromUserId',
        label: '下级下单人ID',
        show: true,
        width: '120',
      }, {
        field: 'fromUserPhone',
        label: '下单人手机号',
        show: true,
        width: '140',
      }, {
        field: 'orderId',
        label: '业务订单号',
        show: true,
        width: '',
      }, {
        field: 'basePoints',
        label: '充值基准额',
        show: true,
        width: '120',
      }, {
        field: 'rebateRate',
        label: '分润比例',
        show: {
          type: 'ratio'
        },
        width: '100',
      }, {
        field: 'rebatePoints',
        label: '获取积分数',
        show: true,
        width: '140',
      }, {
        field: 'createTime',
        label: '入账时间',
        show: {
          type: 'datetime'
        },
        width: '160',
      }],
      operate: [],
      formFields: {
        addTitle: '补录分润记录',
        updateTitle: '修改分润记录',
        model: [{
          field: 'agentId',
          label: '代理',
          type: 'select',
          selectUrl: '/agent/getAll',
          selectData: [],
          placeholder: '请选择代理',
          add: true,
          update: true,
        }, {
          field: 'beneficiaryUserId',
          label: '收益人ID',
          type: 'textarea',
          rules: [{message: '请输入分红归属人ID', trigger: 'blur', required: true}],
          add: true,
          update: true,
        }, {
          field: 'level',
          label: '层级(1/2)',
          type: 'textarea',
          rules: [{message: '请输入层级', trigger: 'blur', required: true}],
          add: true,
          update: true,
        }, {
          field: 'fromUserId',
          label: '下单下级ID',
          type: 'textarea',
          rules: [{message: '请输入来源用户ID', trigger: 'blur', required: true}],
          add: true,
          update: true,
        }, {
          field: 'fromUserPhone',
          label: '下单下级手机',
          type: 'textarea',
          add: true,
          update: true,
        }, {
          field: 'basePoints',
          label: '订单基准积分',
          type: 'textarea',
          add: true,
          update: true,
        }, {
          field: 'rebateRate',
          label: '切分比例',
          type: 'textarea',
          add: true,
          update: true,
        }, {
          field: 'rebatePoints',
          label: '最终拨发代币',
          type: 'textarea',
          rules: [{message: '请输入拨发的数额', trigger: 'blur', required: true}],
          add: true,
          update: true,
        }, {
          field: 'remark',
          label: '人工备注',
          type: 'textarea',
          add: true,
          update: true,
        }],
      }
    }
  }
}
</script>
